
import type { PopperProps } from '@mui/material/Popper';
import Popper from '@mui/material/Popper';
import React from 'react';

import type {OptionType } from './common';
import { calcLongestOptionLabelWidth } from './common';

interface ComponentProps extends PopperProps {
  options: OptionType[];
  e2eId?: string;
}

function PopperComponent({ options, e2eId, ...otherProps }: ComponentProps) {
  const ref = React.createRef<HTMLDivElement>();
  const [maxWidth, setMaxWidth] = React.useState('100%');

  // Recalculate the menu length on the fly as it might change for remote options
  const longestOptionLabelWidth = calcLongestOptionLabelWidth(options);

  React.useEffect(() => {
    if (ref && ref.current) {
      setMaxWidth(`${document.body.offsetWidth - ref.current.getBoundingClientRect().x - 16}px`);
    }
  }, [ref]);

  return (
    <Popper
       
      {...otherProps}
      ref={ref}
      data-e2e-form-selection-options={e2eId}
      style={{
        // Add left, right padding and 18px for potential vertical scrollbar
        width: longestOptionLabelWidth === 0 ? 'auto' : `${((longestOptionLabelWidth) + 16 + 16 + 18)}px`,
        // Limit the menu expansion to the viewport (edge case with very long typing)
        maxWidth,
        minWidth: '100px',
      }}
      className={`${otherProps.className || ''} autosuggestPopper`}
    />
  );
}

export default PopperComponent;
